export default "__VITE_ASSET__lWg2I2uF__"